import React from 'react'
import Communities from '../Components/Communities'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'

const Community = () => {
    return (
        <>
            <Navbar />
            <Communities/>
            <Footer/>
        </>
    )
}

export default Community